import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";
import type { FieldDebateQuota } from "@/lib/fieldDebateQuota";

export type { FieldDebateQuota };

/**
 * FD Stage 3 quota counters (builds + refreshes used/limit this month).
 * Invalidated by useFieldDebateGenerate's terminal handlers — a pending
 * batch build consumes headroom immediately, so `batch_submitted` counts.
 */
export function useFieldDebateQuota(conceptId: string) {
  return useQuery({
    queryKey: ["field-debate-quota", conceptId],
    queryFn: () =>
      apiClient
        .get(`api/concepts/${conceptId}/field-debate/quota`)
        .json<FieldDebateQuota>(),
    staleTime: 30_000,
  });
}
